export function isNavigableUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function resolveOriginalBriefUrl(script: {
  originalBriefUrl?: string | null;
  rationale?: string | null;
}): string | null {
  const fromField = script.originalBriefUrl?.trim();
  if (fromField) return fromField;

  const rationale = script.rationale?.trim();
  if (rationale && isNavigableUrl(rationale)) return rationale;

  return null;
}

/** Hide rationale when it only duplicates the original brief URL (legacy imports). */
export function shouldShowScriptRationale(script: {
  originalBriefUrl?: string | null;
  rationale?: string | null;
}): boolean {
  const rationale = script.rationale?.trim();
  if (!rationale) return false;

  const briefUrl = resolveOriginalBriefUrl(script);
  if (briefUrl && rationale === briefUrl) return false;

  return true;
}
